import { render, staticRenderFns } from "./CopyBoard.vue?vue&type=template&id=44c374ac&lang=true&"
import script from "./CopyBoard.vue?vue&type=script&lang=js&"
export * from "./CopyBoard.vue?vue&type=script&lang=js&"
import style0 from "./CopyBoard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports